export const PRODUCT_ISO_CODE_FIELDS: Record<string, string> = {
  metric: 'PIMOrderingCodeANSI_STR',
  imperial: 'PLM_OrderingCodeISO_STR'
};
